import * as THREE from 'three'
import gsap from 'gsap'
import { Color } from 'three'

export default class LineCube
{
    constructor (size, node)
    {
        size += 0.001

        this.cube = new THREE.Object3D()

        if (node) this.color = node.colorA
        else this.color = new THREE.Color("#666699")

        const material = new THREE.LineBasicMaterial({color: this.color})
        material.transparent = true
        material.side = THREE.DoubleSide
        let points = []
        this.lines = []
        let geometry = null
        let materialInstance = null

        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, 0  + 0.5).multiplyScalar(size))
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, 0  + 0.5).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line1 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line1)
        this.cube.add(line1)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, 0 + 0.5).multiplyScalar(size) )
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line2 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line2)
        this.cube.add(line2)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line3 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line3)
        this.cube.add(line3)

        points = []
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line4 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line4)
        this.cube.add(line4)

        points = []
        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line5 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line5)
        this.cube.add(line5)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line6 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line6)
        this.cube.add(line6)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line7 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line7)
        this.cube.add(line7)

        points = []
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line8 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line8)
        this.cube.add(line8)

        points = []
        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line9 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line9)
        this.cube.add(line9)

        points = []
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 0 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line10 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line10)
        this.cube.add(line10)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 1 - 0.5, -1 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line11 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line11)
        this.cube.add(line11)

        points = []
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, 0 + 0.5 ).multiplyScalar(size) )
        points.push( new THREE.Vector3( 1 - 0.5, 0 + 0.5, -1 + 0.5 ).multiplyScalar(size) )
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        materialInstance = new THREE.LineBasicMaterial()
        materialInstance.copy(material)
        const line12 = new THREE.Line( geometry, materialInstance )
        this.lines.push(line12)
        this.cube.add(line12)

        //this.show ()

        return this.cube
    }

    show () {
        const myColor = new THREE.Color(1,1,1,1)
        myColor.copy(this.color)
        const globalDelay = 0.001
        for (let index = 0; index < this.lines.length; index++) {
            const delay = 0.001
            const lineMat = this.lines[index].material
            gsap.to(this.lines[index].material, {opacity: 0.0, duration: 0.001, delay: 0, ease: 'power3.easeIn'})
            gsap.to(this.lines[index].material, {opacity: 1.0, duration: 0.001, delay: 0.01 + delay, ease: 'power3.easeIn'})
            gsap.to(this.lines[index].material, {opacity: 0.7, duration: 0.001, delay: 0.002 + delay, ease: 'power3.easeIn'})

            this.lines[index].position.set(0,-0.3 * Math.random()*0.6,0 )
            this.lines[index].rotation.x = -3 + Math.random() * 6
            this.lines[index].rotation.y = -3 + Math.random() * 6
            this.lines[index].rotation.z = -3 + Math.random() * 6
            gsap.to(this.lines[index].position, {x: 0.0, y: 0.0, z: 0.0, duration: 0.001, delay: globalDelay + 0.15, ease: 'power3.easeIn'})
            gsap.to(this.lines[index].rotation, {y: 0.0, x: 0.0, z: 0.0, duration: 0.001, delay: globalDelay + 0.15, ease: 'power3.easeIn'})
        }
    }
}